/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Date_Picker_Last_WeekInputs */

const fr_date_picker_last_week = /** @type {(inputs: Date_Picker_Last_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il y a 7 jours`)
};

const en_date_picker_last_week = /** @type {(inputs: Date_Picker_Last_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7 days ago`)
};

/**
* | output |
* | --- |
* | "7 days ago" |
*
* @param {Date_Picker_Last_WeekInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const date_picker_last_week = /** @type {((inputs?: Date_Picker_Last_WeekInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Date_Picker_Last_WeekInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_date_picker_last_week(inputs)
	return fr_date_picker_last_week(inputs)
});